/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsControllerFindManyQueryResponse,
  TelegramProductsControllerFindManyQueryParams,
  TelegramProductsControllerFindMany401,
} from '../types/TelegramProductsControllerFindMany.ts';

function getTelegramProductsFindManyUrl() {
  const res = { method: 'GET', url: `/api/telegram/products/many` as const };
  return res;
}

/**
 * {@link /api/telegram/products/many}
 */
export async function telegramProductsFindMany(
  params: TelegramProductsControllerFindManyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsControllerFindManyQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindMany401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsFindManyUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
